
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import thunk from 'redux-thunk';

import authorize from 'store/reducers/authorize';
import notice from 'store/reducers/notice';
import crumbs from 'store/reducers/crumbs';
import toolbar from 'store/reducers/toolbar';

import userprofile from 'store/reducers/userprofile';
import personalization from 'store/reducers/personalization';
import notifications from 'store/reducers/notifications';

// admin operation reducers
import business from "store/reducers/business";
import addons from "store/reducers/addons";
import template from "store/reducers/template";
import stats from "common/store/reducers/stats";

const reducers = combineReducers({
  notice: notice,
  crumbs: crumbs,
  toolbar: toolbar,
  authorize: authorize, 
  notifications: notifications,
  
  personalization: personalization,
  userprofile: userprofile,

  business: business,
  addons: addons,
  template: template,
  stats: stats,
});

const rootreducer = (state, action) => {
  if(action.type === "AUTHORIZE_LOGOUT") {
    state = undefined;
  }

  return reducers(state, action);
}

let composeEnhancers = null;
if (process.env.NODE_ENV === 'development') {
    composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
} else {
    composeEnhancers = compose;
}

const store = createStore(rootreducer, composeEnhancers(
  applyMiddleware(thunk)
));

export default function createStores() {
    return (store);
}